import { boundrieTypes } from "../config";

export function parseStyle(styles: string | undefined) {
    if (!styles) {
        return {};
    }
    return styles
        .split(";")
        .filter((style) => style.split(":")[0] && style.split(":")[1])
        .map((style) => [
            style
                .split(":")[0]
                .trim()
                .replace(/-./g, (c) => c.substr(1).toUpperCase()),
            style.split(":").slice(1).join(":").trim()
        ])
        .reduce(
            (styleObj, style) => ({
                ...styleObj,
                [style[0]]: style[1]
            }),
            {}
        );
}

export function checkScale(currentScale: number, minScale?: number, maxScale?: number) {
    let minValid = false;
    let maxValid = false;
    if (!minScale) {
        minScale = 0;
    }
    if (!maxScale) {
        maxScale = 0;
    }

    if (currentScale <= minScale || minScale === 0) {
        minValid = true;
    }
    if (currentScale >= maxScale || maxScale === 0) {
        maxValid = true;
    }

    if (minValid && maxValid) {
        return true;
    }

    return false;
}

export function replaceParam(paramName: string, paramValue: string) {
    let url = window.location.href;
    const pattern = new RegExp("\\b(" + paramName + "=).*?(&|#|$)");
    if (url.search(pattern) >= 0) {
        return url.replace(pattern, "$1" + paramValue + "$2");
    }
    url = url.replace(/[?#]$/, "");
    return url + (url.indexOf("?") > 0 ? "&" : "?") + paramName + "=" + paramValue;
}

export function inIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

export function isMobile() {
    return navigator.maxTouchPoints > 0;
}

export function isExpandAllowed(rule: boundrieTypes | undefined) {
    if (!rule || rule === "none" || (rule === "iframe" && !inIframe())) {
        return true;
    }
    return false;
}
